// extracted by mini-css-extract-plugin
module.exports = {"root":"statisticsSummary_root__1E8gK","message":"statisticsSummary_message__1wkxf","chartWrapper":"statisticsSummary_chartWrapper__1QXQm"};